module.exports = __webpack_public_path__ + "img/D202109_2.9e89f47e.jpg";